"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ListBullets: ['list-bullets', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.000 3.998 A2.500 2.500 0 1 0 5.000 3.998 A2.500 2.500 0 1 0 0.000 3.998 Z', 'M8.5,5H23a1,1,0,0,0,0-2H8.5a1,1,0,0,0,0,2Z', 'M0.000 11.998 A2.500 2.500 0 1 0 5.000 11.998 A2.500 2.500 0 1 0 0.000 11.998 Z', 'M23,11H8.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M0.000 19.998 A2.500 2.500 0 1 0 5.000 19.998 A2.500 2.500 0 1 0 0.000 19.998 Z', 'M23,19H8.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z']],
  ListNumbers: ['list-numbers', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.75,4.5h15a1,1,0,0,0,0-2h-15a1,1,0,0,0,0,2Z', 'M22.75,11h-15a1,1,0,1,0,0,2h15a1,1,0,0,0,0-2Z', 'M22.75,19.5h-15a1,1,0,0,0,0,2h15a1,1,0,0,0,0-2Z', 'M2.212,17.248A2,2,0,0,0,.279,18.732a.75.75,0,1,0,1.45.386.5.5,0,1,1,.483.63.75.75,0,1,0,0,1.5.5.5,0,1,1-.482.635.75.75,0,1,0-1.445.4,2,2,0,1,0,3.589-1.648.251.251,0,0,1,0-.278,2,2,0,0,0-1.662-3.111Z', 'M4.25,10.748a2,2,0,0,0-4,0,.75.75,0,0,0,1.5,0,.5.5,0,0,1,1,0,1.031,1.031,0,0,1-.227.645L.414,14.029A.75.75,0,0,0,1,15.248H3.5a.75.75,0,0,0,0-1.5H3.081a.249.249,0,0,1-.195-.406L3.7,12.33A2.544,2.544,0,0,0,4.25,10.748Z', 'M4,5.248H3.75A.25.25,0,0,1,3.5,5V1.623A1.377,1.377,0,0,0,2.125.248H1.5a.75.75,0,0,0,0,1.5h.25A.25.25,0,0,1,2,2V5a.25.25,0,0,1-.25.25H1.5a.75.75,0,0,0,0,1.5H4a.75.75,0,0,0,0-1.5Z']],
  ListStars: ['list-stars', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.875,5h13a1,1,0,1,0,0-2h-13a1,1,0,0,0,0,2Z', 'M22.875,11h-13a1,1,0,0,0,0,2h13a1,1,0,0,0,0-2Z', 'M22.875,19h-13a1,1,0,0,0,0,2h13a1,1,0,0,0,0-2Z', 'M5.875,3.249H5.142a.25.25,0,0,1-.215-.379l.592-.986a.751.751,0,0,0-1.288-.771l-.642,1.07a.25.25,0,0,1-.428,0l-.642-1.07a.751.751,0,0,0-1.288.771l.592.986a.25.25,0,0,1-.215.379H.875a.75.75,0,1,0,0,1.5h.733a.249.249,0,0,1,.218.126.252.252,0,0,1,0,.252l-.592.986a.751.751,0,0,0,1.288.771l.642-1.07a.25.25,0,0,1,.428,0l.642,1.07a.751.751,0,0,0,1.288-.771l-.592-.986a.252.252,0,0,1,0-.252.249.249,0,0,1,.218-.126h.733a.75.75,0,0,0,0-1.5Z', 'M5.875,11.249H5.142a.25.25,0,0,1-.215-.379l.592-.986a.751.751,0,0,0-1.288-.771l-.642,1.07a.25.25,0,0,1-.428,0l-.642-1.07a.751.751,0,0,0-1.288.771l.592.986a.25.25,0,0,1-.215.379H.875a.75.75,0,0,0,0,1.5h.733a.249.249,0,0,1,.218.126.252.252,0,0,1,0,.252l-.592.986a.751.751,0,0,0,1.288.771l.642-1.07a.25.25,0,0,1,.428,0l.642,1.07a.751.751,0,0,0,1.288-.771l-.592-.986a.252.252,0,0,1,0-.252.249.249,0,0,1,.218-.126h.733a.75.75,0,1,0,0-1.5Z', 'M5.875,19.249H5.142a.25.25,0,0,1-.215-.379l.592-.986a.751.751,0,0,0-1.288-.771l-.642,1.07a.25.25,0,0,1-.428,0l-.642-1.07a.751.751,0,0,0-1.288.771l.592.986a.25.25,0,0,1-.215.379H.875a.75.75,0,0,0,0,1.5h.733a.249.249,0,0,1,.218.126.252.252,0,0,1,0,.252l-.592.986a.751.751,0,0,0,1.288.771l.642-1.07a.25.25,0,0,1,.428,0l.642,1.07a.751.751,0,0,0,1.288-.771l-.592-.986a.252.252,0,0,1,0-.252.249.249,0,0,1,.218-.126h.733a.75.75,0,0,0,0-1.5Z']],
  ListRemove: ['list-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6,2.5H19.5a1,1,0,0,0,0-2H6a1,1,0,0,0,0,2Z', 'M6,8.5H19.5a1,1,0,0,0,0-2H6a1,1,0,0,0,0,2Z', 'M10,13.5a1,1,0,0,0-1-1H6a1,1,0,1,0,0,2H9A1,1,0,0,0,10,13.5Z', 'M2.5.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M2.5,6.5h-1a1,1,0,0,0,0,2h1a1,1,0,1,0,0-2Z', 'M2.5,12.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm3.25,6.5a.75.75,0,0,1-.75.75H15a.75.75,0,0,1,0-1.5h5A.75.75,0,0,1,20.75,17.5Z']],
  ListAdd: ['list-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6,2.5H19.5a1,1,0,0,0,0-2H6a1,1,0,0,0,0,2Z', 'M6,8.5H19.5a1,1,0,0,0,0-2H6a1,1,0,0,0,0,2Z', 'M10,13.5a1,1,0,0,0-1-1H6a1,1,0,1,0,0,2H9A1,1,0,0,0,10,13.5Z', 'M2.5.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M2.5,6.5h-1a1,1,0,0,0,0,2h1a1,1,0,1,0,0-2Z', 'M2.5,12.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm.75,9a.75.75,0,1,1-1.5,0V18.5a.25.25,0,0,0-.25-.25H15a.75.75,0,0,1,0-1.5h1.5a.25.25,0,0,0,.25-.25V15a.75.75,0,1,1,1.5,0v1.5a.25.25,0,0,0,.25.25H20a.75.75,0,0,1,0,1.5H18.5a.25.25,0,0,0-.25.25Z']],
  ListBullets1: ['list-bullets-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.5,5H23a1,1,0,0,0,0-2H8.5a1,1,0,0,0,0,2Z', 'M23,11H8.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M23,19H8.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M1.000 2.498 L4.000 2.498 L4.000 5.498 L1.000 5.498 Z', 'M3.5,1.5h-2A1.5,1.5,0,0,0,0,3V5A1.5,1.5,0,0,0,1.5,6.5h2A1.5,1.5,0,0,0,5,5V3A1.5,1.5,0,0,0,3.5,1.5ZM4,5a.5.5,0,0,1-.5.5h-2A.5.5,0,0,1,1,5V3a.5.5,0,0,1,.5-.5h2A.5.5,0,0,1,4,3Z', 'M1.000 10.498 L4.000 10.498 L4.000 13.498 L1.000 13.498 Z', 'M3.5,9.5h-2A1.5,1.5,0,0,0,0,11v2a1.5,1.5,0,0,0,1.5,1.5h2A1.5,1.5,0,0,0,5,13V11A1.5,1.5,0,0,0,3.5,9.5ZM4,13a.5.5,0,0,1-.5.5h-2A.5.5,0,0,1,1,13V11a.5.5,0,0,1,.5-.5h2A.5.5,0,0,1,4,11Z', 'M1.000 18.498 L4.000 18.498 L4.000 21.498 L1.000 21.498 Z', 'M3.5,17.5h-2A1.5,1.5,0,0,0,0,19v2a1.5,1.5,0,0,0,1.5,1.5h2A1.5,1.5,0,0,0,5,21V19A1.5,1.5,0,0,0,3.5,17.5ZM4,21a.5.5,0,0,1-.5.5h-2A.5.5,0,0,1,1,21V19a.5.5,0,0,1,.5-.5h2A.5.5,0,0,1,4,19Z']]
};
exports["default"] = _default;